<template>
  <div v-if="showInfo" class="space-y-2">
    <!-- Both limits reached -->
    <div
      v-if="imageLimitReached && videoLimitReached"
      class="p-2 bg-blue-50 dark:bg-blue-900/20 rounded text-xs text-blue-700 dark:text-blue-300"
    >
      <i class="pi pi-info-circle mr-1" />
      {{
        $t("maxMediaReached", {
          platform: platform,
          maxImages: String(maxImages),
          maxVideos: String(maxVideos),
        })
      }}
    </div>
    <!-- Only image limit reached -->
    <div
      v-else-if="imageLimitReached"
      class="p-2 bg-blue-50 dark:bg-blue-900/20 rounded text-xs text-blue-700 dark:text-blue-300"
    >
      <i class="pi pi-info-circle mr-1" />
      {{ $t("maxImagesReached", { platform: platform, max: String(maxImages) }) }}
    </div>
    <!-- Only video limit reached -->
    <div
      v-else-if="videoLimitReached"
      class="p-2 bg-blue-50 dark:bg-blue-900/20 rounded text-xs text-blue-700 dark:text-blue-300"
    >
      <i class="pi pi-info-circle mr-1" />
      {{ $t("maxVideosReached", { platform: platform, max: String(maxVideos) }) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  imageLimitReached?: boolean;
  videoLimitReached?: boolean;
  maxImages?: number;
  maxVideos?: number;
  platform?: string;
}

const props = withDefaults(defineProps<Props>(), {
  imageLimitReached: false,
  videoLimitReached: false,
  maxImages: 0,
  maxVideos: 0,
  platform: "",
});

const showInfo = computed(() => {
  return props.imageLimitReached || props.videoLimitReached;
});
</script>
